import React, { ReactNode, ComponentProps, ChangeEvent, RefObject, useState } from "react";
import { AppFormErrorMessages } from "src/commun/composants/formulaire/AppFormErrorMessage/AppFormErrorMessage";
import styles from "src/commun/composants/formulaire/AppInputPassword/AppInputPassword.scss";
import AppIcon from "src/commun/composants/AppIcon";
import Stack from 'react-bootstrap/Stack';
import { passwordCriteria, testRegex } from "src/commun/utils/ValidationsUtils";
import AppInput from "src/commun/composants/formulaire/AppInput/AppInput";

export type AppInputPasswordProps = {
  name: string;
  label: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  error?: string;
  touched?: boolean;
  children?: ReactNode;
  fieldRef?: RefObject<HTMLInputElement>;
  iconVerif?: boolean;
  criterias?: passwordCriteria[];
} & ComponentProps<"input">;

const AppInputPassword = ({
  label,
  onChange,
  value,
  error,
  touched,
  iconVerif = false,
  criterias,
  ...reste
}: AppInputPasswordProps) => {

  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const inputComponent = (
    <>
      <Stack direction="horizontal">
        <div className={`input mt-4 ${styles.container}`}>
          <AppInput
            type={showPassword ? "text" : "password"}
            onChange={onChange}
            value={value ?? ""}
            required
            {...reste}
          />
          <label>{label}</label>
        </div>
        <AppIcon
          className={`${styles.iconContainer} ${showPassword && styles.iconColorGray}`}
          size="35px"
          name="oeil"
          onClick={handleClickShowPassword}
        />
      </Stack>

      {criterias && criterias.length > 0 && (
        <Stack direction="horizontal">
          {criterias.map(criteria =>
              <span key={criteria.displayLabel} className={`${styles.criteria} ${testRegex(value, criteria.validator) && styles.criteriaValid}`}>
            {criteria.displayLabel}
          </span>
          )}
        </Stack>
      )}

    </>
  );

  const getErrorMessage = () => {
    return <>{error && touched && <AppFormErrorMessages erreurs={error}/>}</>;
  };

  if (iconVerif) {
    return (
      <>
        <div className={styles.inputSuffix}>
          {inputComponent}{" "}
          {value && (
            <AppIcon
              name={touched && !error ? "verification" : ""}
              className={touched && !error ? styles.selectIconVerif : styles.hiddenIconVerif}
              size="32px"
            />
          )}
        </div>
        {getErrorMessage()}
      </>
    );
  }

  return (
    <>
      {inputComponent}
      {getErrorMessage()}
    </>
  );
};

export default AppInputPassword;
